import styled, { css } from 'styled-components'

// Shared mixin for hiding scrollbars
export const hideScrollbarStyles = css`
  -ms-overflow-style: none;
  scrollbar-width: none; 
  &::-webkit-scrollbar {
    display: none;
    width: 0; 
    height: 0;
  }
`

// Shared header with title and close button (used in FilterModal and ShareModal)
export const ModalHeader = styled.div`
  display: flex;
  padding-bottom: 12px;
  justify-content: space-between;
  align-items: flex-start;
  flex-shrink: 0;
  align-self: stretch;
  box-sizing: border-box;
`

// Shared checkbox styling (used in FilterModal, ShareModal, CouponCard)
export const StyledCheckBox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #16AA40!important;
  border-radius: 4px!important;
  outline: 2px auto var(--Neutral-Borders-Mid, #B0B0B0);
  &:checked {
    outline: none;
  }
`

// Shared search input styling (used in SearchAndFilter and ShareModal)
export const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 14px;
  color: #333;
  background: transparent;
  width: 100%;
`

// Shared category chip (used in FilterModal and SearchAndFilter)
export const CategoryChip = styled.div<{ padding?: string, border?: string, background?: string }>`
  display: flex;
  height: 37px;
  padding: ${({ padding }) => padding || '8px 16px'};
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  width: fit-content;
  white-space: nowrap;
  border: ${({ border }) => border || '1px solid var(--Neutral-Borders-Default, #D1D1D1)'};
  &:hover {
    background: #E9ECEF;
    border-color: #DEE2E6;
  }

  &.active {
    background: ${({ background }) => background || '#272727'};
    color: white;
    border-color: #272727;
  }
  cursor: pointer;
`

// Shared flex space-between container (used in multiple places)
export const FlexSpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

`

// Shared flex center container
export const FlexCenter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

// Shared scrollable container with hidden scrollbar
export const ScrollableContainer = styled.div`
  overflow-y: auto;
  max-height: 100%;
  
  ${hideScrollbarStyles}
`

// Shared modal backdrop (used in Coupons.tsx)
export const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;
`

// Shared white container with rounded corners (used in multiple places)
export const WhiteRoundedContainer = styled.div<{ padding?: string, gap?: string }>`
  display: flex;
  padding: ${({ padding }) => padding || '16px'};
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ gap }) => gap || '8px'};
  align-self: stretch;
  border-radius: 12px;
  background: var(--Neutral-Surface-Minimal, #FFF);
  box-sizing: border-box;
`

// Shared modal button container
export const ModalButtonContainer = styled.div<{ isFixed?: boolean }>`
  ${({ isFixed }) => isFixed && css`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  `}
  display: flex;
  width: ${({ isFixed }) => isFixed ? '100%' : '640px'};
  padding: 16px;
  align-items: center;
  border-radius: 16px;
  justify-content: flex-end;
  gap: 16px;
  background: var(--Neutral-Surface-Minimal, #FFF);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  @media (max-width: 1081px) {
    width: 100%;
  }
`

export const Header = styled.div`
display: flex;
height: 94px;
justify-content: space-between;
align-items: flex-start;
flex-shrink: 0;
align-self: stretch;
@media (max-width: 1081px) {
  height: 40px;
}
`

export const HeaderFrame = styled.div`
display: flex;
height: 94px;
align-items: flex-start;
gap: 17px;
@media (max-width: 1081px) {
  height: 40px;
}
`

export const TextFrame = styled.div`
display: flex;
width: 444px;
flex-direction: column;
align-items: flex-start;
gap: 4px;
@media (max-width: 1081px) {
  width: 100%;
}
`


export const IconFrame = styled.div`
display: flex;
height: 94px;
justify-content: center;
align-items: center;
gap: 10px;
border-left: 1px solid var(--Neutral-Borders-Default, #D1D1D1);
@media (max-width: 1081px) {
  display: none;
}
`
// Shared flex line with gap and alignment
export const FlexLineWithGap = styled.div<{ gap?: string }>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${({ gap }) => gap || '8px'};
  align-self: stretch;
  box-sizing: border-box;
`

// Shared centered modal container
export const CenteredModal = styled.div<{ width?: string, height?: string }>`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  width: ${({ width }) => width || '627px'};
  height: ${({ height }) => height || 'auto'};
  padding: 24px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  flex-shrink: 0;
  border-radius: 16px;
  background: var(--Neutral-Surface-Light, #F6F6F6);
  z-index: 9999;
  @media (max-width: 1081px) {
    width: 90%;
    height: auto;
    max-height: 90vh;
    overflow-y: auto;
  }
`

export const DueDate = styled.div<{ isExpired?: boolean }>`
display: flex;
padding: 6px 8px;
justify-content: flex-end;
align-items: center;
gap: 10px;
border-radius: 8px;
background: ${({ isExpired }) => isExpired ? '#B0B0B0' : 'var(--Alert-Surface-Subtle, #FFE2E7)'};
`

export const CouponCompanyLogoWrapper = styled.div`
display: flex;
width: 101px;
height: 48px;
padding: 10px;
justify-content: center;
align-items: center;
gap: 10px;
position: absolute;
bottom: 20px;
right: 20px;
border-radius: 8px;
background: var(--Neutral-Surface-Minimal, #FFF);
`

export const SearchContainer = styled.div`
display: flex;
width: 595px;
padding: 12px;
justify-content: flex-end;
align-items: center;
gap: 10px;
border-radius: 100px;
background: var(--Neutral-Surface-Minimal, #FFF);
box-sizing: border-box;
@media (max-width: 1081px) {
  width: 100%;
}
`

export const CheckBoxConatiner = styled.div`
display: flex;
padding: 11px;
justify-content: center;
align-items: center;
border-radius: 100px;
`


export const CheckBoxLineContainer = styled.div`
display: flex;
padding: 16px;
flex-direction: row;
align-items: center;
gap: 8px;
align-self: stretch;
border-radius: 12px;
background: var(--Neutral-Surface-Minimal, #FFF);
box-sizing: border-box;
`

// People display components (shared between ShareModal and BlockCouponsModal)
export const PepoleDisplayContainer = styled.div<{ justifyContent?: string }>`
display: flex;
height: 96px;
padding: 6px 16px;
justify-content: ${({ justifyContent }) => justifyContent || ''};
align-items: center;
gap: 14px;
flex-shrink: 0;
align-self: stretch;
border-radius: 15px;
background: var(--Neutral-Surface-Minimal, #FFF);
`

export const SelectedMembersContainer = styled.div`
display: flex;
align-items: center;
gap: 180px;
align-self: stretch;
`

export const SearchListContainer = styled.div`
display: flex;
flex-direction: column;
align-items: stretch;
padding-bottom: 72px;
width: 100%;
gap: 12px;
align-self: stretch;
max-height: 450px;
overflow-y: auto;
${hideScrollbarStyles}
`

export const IndicationLetterContainer = styled.div`
display: flex;
height: 10px;
padding: 12px 0;
align-items: center;
gap: 10px;
align-self: stretch;
`

export const ListItem = styled.div`
display: flex;
height: 72px;
align-self: stretch;
padding: 12px 4px;
align-items: center;
gap: 10px;
border-bottom: 1px solid var(--Neutral-Borders-Default, #D1D1D1);
border-radius: 10px;
background: var(--Neutral-Surface-Minimal, #FFF);
`

export const PersonDisplayContainer = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 4px;
`

export const BlueBubbleWithShortNameContainer = styled.div`
display: flex;
position: relative;
width: 48px;
height: 48px;
flex-direction: column;
justify-content: center;
align-items: center;
gap: 4px;
border-radius: 1000px;
background: var(--Brand-Surface-Light, #D6F3FF);
`

export const MinusIconContainer = styled.div`
position: absolute;
top: -7px;
left: -4px;
display: flex;
width: 24px;
height: 24px;
justify-content: center;
align-items: center;
gap: 8.283px;
flex-shrink: 0;
border-radius: 828.308px;
background: var(--Neutral-Surface-High, #4F4F4F);
cursor: pointer;
`

export const CheckBoxContainer = styled.div`
display: flex;
padding: 11px;
justify-content: center;
align-items: center;
`

export const SmallImageContainer = styled.div<{ border?: string, width: string }>`
  display: flex;
  width: ${({ width }) => width} ;
  aspect-ratio: 4 / 3;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 39.772px;
  border-radius: 10.096px;
  border: ${({ border }) => border ? border : 'none'};
  background: var(--Neutral-Surface-Light, #F6F6F6);
  cursor: pointer;
  overflow: visible;
  position: relative;

  @media (max-width: 1081px) {
    width: 96px;
    aspect-ratio: 4 / 3;
    padding: 4px;
    border: ${({ border }) => border ? border : 'none'};
  }
`

export const SmallImage = styled.img<{ src?: string }>`
  width: 100%;
  height: 100%;
  flex-shrink: 0;
  aspect-ratio: 4 / 3;
  border-radius: 10.096px;
  object-fit: cover;
  position: relative;
  z-index: 0;

`